import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  eyebrow: 'Catalog AKIS',
  heading: 'Ce găsiți în platformă',
  lead: 'Explorați organizații, servicii, instruiri, publicații, oportunități de finanțare, evenimente și resurse agricole.',
  searchAll: 'Căutare în tot conținutul',
  badgePublic: 'Public',
  mapAction: 'Vizualizare interactivă',

  researchTitle: 'Organizații de cercetare și inovare',
  researchDesc:
    'Profiluri instituționale, proiecte, infrastructură de cercetare și rezultate științifice.',
  advisorsTitle: 'Consilieri agricoli',
  advisorsDesc: 'Registrul consilierilor validați, specializări și acoperirea teritorială.',
  servicesTitle: 'Servicii de consiliere agricolă',
  servicesDesc: 'Furnizori, tipuri de servicii și activități de consiliere înregistrate.',
  trainingTitle: 'Formare profesională agroalimentară',
  trainingDesc:
    'Programe și sesiuni de instruire, înscriere și certificare prin platforma e-learning.',
  libraryTitle: 'Biblioteca digitală AKIS',
  libraryDesc: 'Ghiduri, standarde, rapoarte, studii și materiale de instruire cu acces deschis.',
  fundingTitle: 'Subvenții și granturi',
  fundingDesc: 'Catalogul măsurilor de sprijin, ghiduri de aplicare și criterii de eligibilitate.',
  eventsTitle: 'Evenimente de transfer de cunoștințe',
  eventsDesc: 'Calendarul național al demonstrațiilor, atelierelor și conferințelor.',
  associationsTitle: 'Asociații și organizații profesionale',
  associationsDesc: 'Forme asociative, forumuri tematice și spații de colaborare.',
  mapTitle: 'Harta AKIS',
  mapDesc: 'Tot conținutul localizabil, cu simboluri diferențiate pe categorii.',

  unitProjects: '{{n}} proiecte',
  unitAdvisors: '{{n}} consilieri activi',
  unitServices: '{{n}} servicii',
  unitPrograms: '{{n}} programe deschise',
  unitResources: '{{n}} resurse',
  unitCalls: '{{n}} apeluri',
  unitEvents: '{{n}} evenimente',
  unitOrganisations: '{{n}} organizații',
} as const;

const en = {
  eyebrow: 'AKIS catalogue',
  heading: 'What the platform holds',
  lead: 'Explore organisations, services, training, publications, funding opportunities, events and agricultural resources.',
  searchAll: 'Search all content',
  badgePublic: 'Public',
  mapAction: 'Interactive view',

  researchTitle: 'Research and innovation organisations',
  researchDesc: 'Institutional profiles, projects, research infrastructure and scientific results.',
  advisorsTitle: 'Agricultural advisers',
  advisorsDesc: 'The register of validated advisers, specialisations and territorial coverage.',
  servicesTitle: 'Agricultural advisory services',
  servicesDesc: 'Providers, service types and registered advisory activities.',
  trainingTitle: 'Agri-food vocational training',
  trainingDesc:
    'Training programmes and sessions, enrolment and certification through the e-learning platform.',
  libraryTitle: 'AKIS digital library',
  libraryDesc: 'Open-access guides, standards, reports, studies and training materials.',
  fundingTitle: 'Subsidies and grants',
  fundingDesc: 'The catalogue of support measures, application guides and eligibility criteria.',
  eventsTitle: 'Knowledge-transfer events',
  eventsDesc: 'The national calendar of demonstrations, workshops and conferences.',
  associationsTitle: 'Professional associations and organisations',
  associationsDesc: 'Associative forms, thematic forums and collaboration spaces.',
  mapTitle: 'AKIS map',
  mapDesc: 'All locatable content, with symbols differentiated by category.',

  unitProjects: '{{n}} projects',
  unitAdvisors: '{{n}} active advisers',
  unitServices: '{{n}} services',
  unitPrograms: '{{n}} open programmes',
  unitResources: '{{n}} resources',
  unitCalls: '{{n}} calls',
  unitEvents: '{{n}} events',
  unitOrganisations: '{{n}} organisations',
} satisfies Translation<keyof typeof ro>;

export const publicCatalogCards = { ro, en } satisfies Dictionary;

export type PublicCatalogCardsKey = keyof typeof ro;
